export const normalizeCurrencyPrice = (value) => {
  if (value === undefined || value === null || value === "") {
    return value;
  }

  const numericValue = Number(value);

  if (Number.isNaN(numericValue)) {
    return value;
  }

  return Number(numericValue.toFixed(2));
};
